import { useCallback } from 'react';
import { sdk } from '@/sdk';
import { Category } from '@shared/types/product/Category';
import useSWR from 'swr';

export const useCategories = () => {
  // Commented out for faster login redirect - categories can be loaded lazily
  // const { data: categoriesData, mutate: mutateCategories } = useSWR('/action/product/queryCategories?format=tree', () =>
  //   sdk.composableCommerce.product.queryCategories({ format: 'tree', limit: 99 }),
  // );

  // const { data: flatCategoriesData, mutate: mutateFlatCategories } = useSWR(
  //   '/action/product/queryCategories?format=flat',
  //   () => sdk.composableCommerce.product.queryCategories({ format: 'flat', limit: 99 }),
  // );

  // Provide empty data for faster initial load
  const categoriesData = { isError: false, data: { items: [] } };
  const flatCategoriesData = { isError: false, data: { items: [] } };

  const categories = categoriesData?.isError ? [] : ((categoriesData?.data?.items as Category[]) ?? []);
  const flatCategories = flatCategoriesData?.isError ? [] : ((flatCategoriesData?.data?.items as Category[]) ?? []);

  const mutate = useCallback(() => {
    // mutateCategories();
    // mutateFlatCategories();
    // No-op for now - categories disabled for performance
  }, []);

  return { categories, flatCategories, mutate };
};